import React, { useState } from 'react';
import { Rocket, CheckCircle2, Clock3, Wrench } from 'lucide-react';
import ServiceFlowCanvas from './ServiceFlowCanvas';
import { ALL_PROJECT_FLOWS, kloudPilotAgentsStatus } from './projectsFlowsData';

const STATE_UI = {
  live:     { label: 'Conectado', color: '#00FF66', Icon: CheckCircle2 },
  pending:  { label: 'Falta conectar', color: '#ff9b00', Icon: Clock3 },
  building: { label: 'En construcción', color: '#04d9ff', Icon: Wrench },
};

function StatusInfographic({ items }) {
  return (
    <div className="mb-5 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {items.map((item) => {
        const ui = STATE_UI[item.state];
        return (
          <div
            key={item.label}
            className="rounded-xl border p-3"
            style={{ borderColor: `${ui.color}33`, background: `${ui.color}0d` }}
          >
            <div className="flex items-center gap-2 text-xs font-bold" style={{ color: ui.color }}>
              <ui.Icon size={14} /> {ui.label}
            </div>
            <div className="mt-1 text-sm font-semibold text-white/90">{item.label}</div>
            <div className="mt-1 text-xs text-white/50">{item.note}</div>
          </div>
        );
      })}
    </div>
  );
}

export default function ProyectosPage() {
  const [activeKey, setActiveKey] = useState(ALL_PROJECT_FLOWS[0].key);
  const activeProject = ALL_PROJECT_FLOWS.find((p) => p.key === activeKey) || ALL_PROJECT_FLOWS[0];

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#1a0a14] via-[#12081a] to-[#0a0a14] text-white p-6">
      <div className="mb-6 flex items-center gap-3">
        <div className="p-3 rounded-2xl bg-[#ff0080]/12 border border-[#ff0080]/35">
          <Rocket className="w-6 h-6" style={{ color: '#ff0080' }} />
        </div>
        <div>
          <h1 className="text-2xl font-bold" style={{ color: '#ff0080' }}>Proyectos</h1>
          <p className="text-sm text-white/50">
            Innovation · Avance de iniciativas por proyecto
          </p>
        </div>
      </div>

      <div className="mb-5 flex flex-wrap items-center gap-2">
        {ALL_PROJECT_FLOWS.map((project) => {
          const active = activeKey === project.key;
          return (
            <button
              key={project.key}
              onClick={() => setActiveKey(project.key)}
              className={`inline-flex items-center gap-2 rounded-xl border px-4 py-2 text-sm font-medium transition-all ${
                active
                  ? 'border-[#ff0080]/60 bg-[#ff0080]/20 text-[#ffaacc] shadow-[0_0_18px_rgba(255,0,128,0.25)]'
                  : 'border-[#ff0080]/15 bg-black/20 text-white/60 hover:border-[#ff0080]/40 hover:text-white/85'
              }`}
            >
              {project.label}
            </button>
          );
        })}
      </div>

      {activeProject.key === 'kloud-pilot-agents' && <StatusInfographic items={kloudPilotAgentsStatus} />}

      <ServiceFlowCanvas flow={activeProject} />
    </div>
  );
}
